<!-- 服务开单 -->
<template>
  <div class="add_service_order" v-loading="loading">
    <div class="container">
      <div class="back">
        <back />
      </div>
      <div class="service_list tabs">
        <el-tabs v-model="type" @tab-click="handleClickType">
          <el-tab-pane v-for="(item, index) in types" :key="index" :label="item.label" :name="item.name"></el-tab-pane>
        </el-tabs>
        <el-tabs v-if="type == '1'" v-model="categoryId" @tab-click="handleClickTabs">
          <el-tab-pane v-for="(item, index) in category" :key="index" :label="item.categoryName" :name="item.categoryId"></el-tab-pane>
        </el-tabs>
        <el-empty v-if="list.length == 0" description="暂无数据"></el-empty>
        <div class="list">
          <listCard v-for="(item, index) in list" :key="index" :obj="item" @change="changeProject" />
        </div>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
      </div>
    </div>
    <div class="order">
      <div class="selected" v-if="!member.memberCode">
        <div class="select_member" @click="showMemberList">
          <i class="el-icon-circle-plus"></i>
          <span>选择会员</span>
        </div>
        <div class="add_member" @click="showAddMember">
          <i class="el-icon-circle-plus"></i>
          <span>新增会员</span>
        </div>
      </div>
      <div class="member_info" v-if="member.memberCode">
        <i class="close el-icon-error" @click="removeMember"></i>
        <div class="avatar">
          <img :src="member.logoUrl" />
        </div>
        <div class="info">
          <div class="name">
            <div class="text">{{ member.memberName }}</div>
            <div class="balance">余额：{{ member.balance }}元</div>
          </div>
          <div class="cards">会员卡号：{{ member.memberCode }}</div>
        </div>
      </div>
      <div class="order_list">
        <div class="item" v-for="(item, index) in order" :key="index">
          <i class="close el-icon-error" @click="removeItem"></i>
          <div class="cell cell1">
            <div class="name" v-if="item.projectId">{{ item.projectName }}</div>
            <div class="name" v-if="item.packageId">{{ item.packageName }}</div>
            <div class="price">￥{{ item.price }}</div>
          </div>
          <div class="cell">
            <div class="technician">次数：{{ item.projectCount }}</div>
            <div class="duration">时长：{{ item.durationMinute }}分钟</div>
          </div>
        </div>
      </div>
      <div class="order_total">
        <div class="cell cell1">
          <div class="name">
            <span class="text" v-if="type == 2">套餐价格：￥{{ ruleForm.orderAmount }}</span>
          </div>
          <div class=""></div>
        </div>
      </div>
      <div class="add_order">
        <el-button type="primary" @click="placeOrder(1)" :loading="btnloading">开单</el-button>
        <el-button type="primary" plain @click="placeOrder(2)" :loading="btnloading">挂单</el-button>
      </div>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :destroy-on-close="true">
      <!-- 扫码注册会员 -->
      <div class="dialog_changevip" v-if="dialogTitle == '扫码注册会员'">
        <vue-qr :correctLevel="3" :autoColor="false" colorDark="#1777D9" :text="codeUrl" :size="250"></vue-qr>
        <div class="text">
          <i class="el-icon-warning"></i>
          <span>开单前请先扫码注册会员</span>
        </div>
      </div>

      <!-- 选择会员 -->
      <div class="dialog_member" v-if="dialogTitle == '选择会员'">
        <el-input v-model="memberCode" placeholder="请输入会员卡号" clearable @change="searchMember" />
        <el-input v-model="memberTel" placeholder="请输入电话号码" clearable @change="searchMember" style="margin-left: 10px" />
        <div class="dialog_member_list">
          <div class="item" v-for="(item, index) in memberList" :key="index" :class="activeMember == item.id ? 'is_ac' : ''" @click="changeMember(item)">
            <div class="avatar">
              <img :src="item.logoUrl" />
            </div>
            <div class="info">
              <div class="name">
                <div class="text">{{ item.memberName }}</div>
                <div class="balance">余额：{{ item.balance }}元</div>
              </div>
              <div class="num">
                <div class="cards">会员卡号：{{ item.memberCode }}</div>
                <div class="cards">电话号码：{{ item.memberTel }}</div>
                <div class="cards">注册时间：{{ item.createdTime }}</div>
              </div>
            </div>
          </div>
        </div>
        <el-empty v-if="memberList.length == 0" description="暂无数据"></el-empty>
        <el-pagination class="pg_input" background @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page.sync="currentPage1" :page-size="pageSize1" :page-sizes="pageSizeArr1" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount1"></el-pagination>
      </div>

      <!-- 新增会员 -->
      <div class="dialog_member" v-if="dialogTitle == '新增会员'">
        <el-form :model="addForm" :rules="addRules" ref="addForm" label-width="110px" class="addForm">
          <el-row type="flex" justify="center">
            <el-form-item label="会员名称" prop="memberName">
              <el-input v-model="addForm.memberName" placeholder="请输入会员名称"></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center">
            <el-form-item label="手机号码" prop="memberTel">
              <el-input v-model="addForm.memberTel" placeholder="请输入手机号码"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>

      <!-- 选择员工 -->
      <div class="dialog_employee tabs" v-if="dialogTitle == this.projectName">
        <el-tabs v-model="departmentId" @tab-click="handleClickEmployeeTabs">
          <el-tab-pane v-for="(item, index) in staffDepartmentList" :key="index" :label="item.departmentName" :name="item.departmentId"></el-tab-pane>
        </el-tabs>
        <div class="employee_list" v-loading="employeeloading">
          <div class="employee_list_item" v-for="(item, index) in staffList" :key="index" :class="employeeId == item.employeeId ? 'employee_ac' : ''" @click="changeStaff(item)">
            <div class="icon">
              <i class="el-icon-success" v-if="employeeId == item.employeeId"></i>
              <i class="el-icon-circle-check" v-else></i>
            </div>
            <div class="avatar">
              <img :src="item.avatarUrl || require('@/assets/img/staff.png')" width="60" height="60" />
            </div>
            <div class="info">
              <div class="name overt">{{ item.employeeName }}</div>
              <div class="code overt">员工编号：{{ item.employeeCode }}</div>
              <div class="num">今日服务次数：{{ item.count }}次</div>
            </div>
          </div>
        </div>
        <el-empty v-if="staffList.length == 0" description="暂无数据"></el-empty>
        <el-pagination class="pg_input" background @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page.sync="currentPage2" :page-size="pageSize2" :page-sizes="pageSizeArr2" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount2"></el-pagination>
      </div>

      <!-- 支付 -->
      <div class="dialog_member" v-if="dialogTitle == '支付'">
        <el-form :model="ruleForm" ref="ruleForm" label-width="150px" class="ruleForm">
          <el-row type="flex" justify="center">
            <el-form-item label="支付方式">
              <el-select v-model="ruleForm.payType" @change="changePayType">
                <!-- <el-option v-for="(item, index) in payTypes" :key="index" :label="item" :value="index"></el-option> -->
                <el-option label="微信" value="1"></el-option>
                <el-option label="现金支付" value="2"></el-option>
                <el-option v-if="ruleForm.memberCode" label="会员卡支付" value="3"></el-option>
                <el-option label="收款二维码" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center" v-if="ruleForm.payType == 3">
            <el-form-item label="会员卡号">
              <el-input v-model="ruleForm.memberCode" placeholder="未选择会员卡" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center" v-if="ruleForm.payType == 3">
            <el-form-item label="账户余额(元)">
              <el-input v-model="ruleForm.balance" placeholder="未选择会员卡" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center">
            <el-form-item label="订单金额(元)">
              <el-input v-model="ruleForm.orderAmount" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center" v-if="ruleForm.payType == 3">
            <el-form-item label="折扣率">
              <el-input v-model="ruleForm.discountRate" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center" v-if="ruleForm.payType == 3">
            <el-form-item label="优惠金额(元)">
              <el-input v-model="ruleForm.discountAmount" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center" v-if="ruleForm.payType == 3">
            <el-form-item label="支付金额(元)">
              <el-input v-model="ruleForm.payAmount" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center" v-if="ruleForm.payType == 1">
            <el-form-item label="付款码">
              <el-input ref="paycode" v-model="ruleForm.payCode" placeholder="请扫描付款码"></el-input>
            </el-form-item>
          </el-row>
          <el-row type="flex" justify="center" v-if="ruleForm.payType == 4 && qrurl">
            <vue-qr :correctLevel="3" :autoColor="false" colorDark="#1777D9" :text="qrurl" :size="250"></vue-qr>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" v-if="dialogTitle == '扫码注册会员'">
        <el-button @click="cancelMember">关 闭</el-button>
      </span>
      <span slot="footer" v-if="dialogTitle == '选择会员'">
        <el-button @click="cancelMember">取 消</el-button>
        <el-button type="primary" @click="confirmMember">确 定</el-button>
      </span>
      <span slot="footer" v-if="dialogTitle == '新增会员'">
        <el-button @click="cancelMember">取 消</el-button>
        <el-button type="primary" @click="confirmAddMember">确 定</el-button>
      </span>
      <span slot="footer" v-if="dialogTitle == this.projectName">
        <el-button @click="cancelEmployee">取 消</el-button>
        <el-button type="primary" @click="confirmEmployee">确 定</el-button>
      </span>
      <span slot="footer" v-if="dialogTitle == '支付' && ruleForm.payType != 4">
        <el-button @click="cancelPay">取 消</el-button>
        <el-button type="primary" :loading="btnloading" @click="confirmPay">确 定</el-button>
      </span>
      <span slot="footer" v-if="dialogTitle == '支付' && ruleForm.payType == 4">
        <el-button @click="cancelPay">取 消</el-button>
        <el-button type="primary" :loading="btnloading" @click="confirmPayNew">我已支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import listCard from "@/components/listCard.vue"
import VueQr from "vue-qr"
function createRuleForm() {
  return {
    payType: "", // 支付类型:1.线上支付,2.现金支付,3会员卡支付
    employeeId: "", // 员工id
    employeeName: "", // 员工name
    memberCode: "", // 会员卡号
    balance: 0, // 会员卡余额
    orderAmount: 0, // 订单金额
    discountRate: "", // 折扣率
    discountAmount: "", // 优惠金额
    payAmount: "", // 支付金额
    projectId: "", // 项目id
    projectName: "", // 项目名字
    payCode: "", // 付款码
    // storeId: this.$store.state.userInfo.bizId, // 门店id
  }
}
export default {
  components: { listCard, VueQr },
  data() {
    return {
      loading: false,
      employeeloading: false,
      btnloading: false,
      dialogVisible: false,
      dialogTitle: "选择会员",
      projectName: "",
      employeeId: "",
      employeeName: "",
      departmentId: "0",
      categoryId: "0",
      memberCode: "", // 会员卡号
      memberTel: "", // 会员手机号
      activeMember: "",
      category: [],
      list: [],
      memberList: [],
      staffList: [],
      staffDepartmentList: [],
      order: [],
      package: {},
      member: {},
      type: "1",
      types: [
        { name: "1", label: "服务项目" },
        { name: "2", label: "服务套餐" },
      ],
      payTypes: { 1: "微信/支付宝", 2: "现金支付", 3: "会员卡支付" },
      qrurl: "",
      ruleForm: createRuleForm(),
      codeUrl: "https://projecth5.ganmiaoedu.com/#/pages/login/register",

      addForm: {
        memberName: "", // 会员名称
        memberTel: "", // 手机号码
      },
      addRules: {
        memberName: [{ required: true, message: "请输入会员名称", trigger: "blur" }],
        memberTel: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
      },

      // 服务列表分页
      currentPage: 1, // 当前页码
      pageSize: 12, // 每页显示的行数
      pageSizeArr: [12, 24, 60], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      // 会员分页
      currentPage1: 1, // 当前页码
      pageSize1: 5, // 每页显示的行数
      pageSizeArr1: [5, 20, 50], // 每页显示的行数(可选)
      totalItemsCount1: 0, // 总记录数（需要从后端获取）
      // 员工分页
      currentPage2: 1, // 当前页码
      pageSize2: 9, // 每页显示的行数
      pageSizeArr2: [9, 18, 54], // 每页显示的行数(可选)
      totalItemsCount2: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.selectProjectCategoryList()
    this.getProjectInfoselectProjectInfoList()
  },
  methods: {
    // 项目分类
    selectProjectCategoryList() {
      this.$axios
        .get(this.$api.projectInfoselectProjectCategoryList)
        .then(res => {
          let list = res.result.map(e => {
            return {
              ...e,
              categoryId: e.categoryId.toString(),
            }
          })
          list.unshift({ categoryId: "0", categoryName: "全部" })
          this.category = list
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 项目列表
    getProjectInfoselectProjectInfoList() {
      let categoryId = this.categoryId
      this.loading = true
      this.$axios
        .post(this.$api.projectInfoselectProjectInfoList, {
          categoryId,
          projectType: 1, // 项目类型:1.服务项目,2.预约项目
          saleStatus: 1, // 销售状态:1.正常,0.停用
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(res => {
          this.list = res.result.list
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 项目套餐列表
    getProjectInfoselectProjectPackageList() {
      this.loading = true
      this.$axios
        .post(this.$api.projectInfoselectProjectPackageList, {
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(res => {
          this.list = res.result.list
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 会员列表
    getMemberList() {
      this.$axios
        .get(this.$api.memberInfopageList, {
          params: {
            memberCode: this.memberCode,
            memberTel: this.memberTel,
            page: this.currentPage1,
            pageSize: this.pageSize1,
          },
        })
        .then(res => {
          this.memberList = res.result.list
          this.totalItemsCount1 = res.result.totalCount
          this.dialogVisible = true
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 员工列表
    getStaffList() {
      this.employeeloading = true
      this.$axios
        .get(this.$api.employeeInfoselectEmployee, {
          params: {
            parentId: this.departmentId == "0" ? "" : this.departmentId,
            storeId: this.$store.state.userInfo.bizId,
            page: this.currentPage2,
            pageSize: this.pageSize2,
          },
        })
        .then(res => {
          this.staffList = res.result.list
          this.totalItemsCount2 = res.result.totalCount
          this.employeeloading = false
        })
        .catch(err => {
          this.employeeloading = false
          this.$message.error(err.desc)
        })
    },
    // 员工部门
    getStaffDepartmentList() {
      this.$axios
        .get(this.$api.departmentInfoselectParentDepartment)
        .then(res => {
          let list = res.result.map(e => {
            return {
              ...e,
              departmentId: e.departmentId.toString(),
            }
          })
          list.unshift({ departmentId: "0", departmentName: "全部" })
          this.staffDepartmentList = list
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    showMemberList() {
      this.dialogTitle = "选择会员"
      this.getMemberList()
    },
    showAddMember() {
      this.dialogTitle = "新增会员"
      this.dialogVisible = true
      this.addForm = {
        memberName: "", // 会员姓名
        memberTel: "", // 手机号码
      }
    },
    // 搜索会员码
    searchMember(e) {
      this.memberList = []
      this.currentPage1 = 1
      this.getMemberList()
    },
    // 切换类型
    handleClickType(e) {
      this.type = e.name
      this.list = []
      this.order = []
      this.package = {}
      this.currentPage = 1
      this.ruleForm.orderAmount = 0
      if (this.type == "1") {
        this.getProjectInfoselectProjectInfoList()
      } else {
        this.getProjectInfoselectProjectPackageList()
      }
    },
    // 切换分类
    handleClickTabs() {
      this.list = []
      this.currentPage = 1
      this.getProjectInfoselectProjectInfoList()
    },
    // 切换员工部门
    handleClickEmployeeTabs() {
      this.staffList = []
      this.currentPage2 = 1
      this.getStaffList()
    },
    // 删除会员
    removeMember() {
      this.member = []
    },
    // 删除项目
    removeItem() {
      this.order = []
      this.employeeId = ""
    },
    // 切换项目
    changeProject(e) {
      this.order = []
      this.package = {}
      if (this.type == 1) {
        this.order.push(e)
      } else {
        this.package = e
        this.order = e.projectInfoList
      }
      this.ruleForm.orderAmount = e.price
      // this.ruleForm.orderAmount = this.order.reduce((item, total) => item + Number(total.price), 0)
      // this.employeeId = ""
      // this.employeeName = ""
      // this.projectName = e.projectName
      // this.dialogTitle = "选择员工"
      // this.dialogTitle = this.projectName
      // this.getStaffDepartmentList()
      // this.getStaffList()
      // this.departmentId = "0"
      // this.dialogVisible = true
    },
    // 切换会员
    changeMember(e) {
      this.activeMember = e.id
      this.member = e
    },
    // 切换员工
    changeStaff(e) {
      this.employeeId = e.employeeId
      this.employeeName = e.employeeName
      this.order = this.order.map(item => {
        return {
          ...item,
          employeeId: e.employeeId,
          employeeName: e.employeeName,
        }
      })
    },
    // // 获取服务支付二维码
    // projectQRCode() {
    //   this.$axios
    //     .post(this.$api.project_QRCode_pay_order, {
    //       title: "项目二维码主动支付",
    //       orderCode: this.ruleForm.orderCode,
    //       payAmount: this.ruleForm.orderAmount, // 支付金额
    //     })
    //     .then(res => {
    //       if (res.code == 100) {
    //         this.qrurl = res.result.qrurl
    //         this.btnloading = false
    //       } else {
    //         this.$message.error(res.desc)
    //       }
    //     })
    //     .catch(err => {
    //       this.$message.error(err.desc)
    //     })
    // },
    // 支付二维码-跳转H5支付
    projectQRCode() {
      this.btnloading = false
      const { orderAmount, id, orderCode } = this.ruleForm
      this.qrurl = `https://producth5.ganmiaoedu.com/pagesA/otherPay/otherPay?payPrice=${orderAmount}&sourceId=${id}&sourceNum=${orderCode}&sourceType=${1}`
    },
    // 切换支付方式
    changePayType(e) {
      if (e == 4) {
        this.btnloading = true
        this.projectQRCode()
      }
      this.$nextTick(() => {
        if (e == 1) {
          this.$refs.paycode.focus()
        }
      })
    },
    cancelMember() {
      this.staffDepartmentList = []
      this.addForm = {
        memberName: "", // 会员姓名
        memberTel: "", // 手机号码
      }
      this.dialogVisible = false
    },
    cancelEmployee() {
      this.employeeId = ""
      this.employeeName = ""
      this.order = this.order.map(item => {
        return {
          ...item,
          employeeId: "",
          employeeName: "",
        }
      })
      this.dialogVisible = false
    },
    cancelPay() {
      this.dialogVisible = false
      this.$router.go(-1)
    },
    // 确定选择会员
    confirmMember() {
      if (this.member.memberCode) {
        this.dialogVisible = false
      } else {
        this.$message.error("请选择会员")
      }
    },
    // 新增会员
    confirmAddMember() {
      this.$axios
        .post(this.$api.memberInfoinsert, {
          memberName: this.addForm.memberName,
          memberTel: this.addForm.memberTel,
        })
        .then(res => {
          this.$message.success("新增成功")
          this.addForm = {
            memberName: "", // 会员姓名
            memberTel: "", // 手机号码
          }
          this.dialogVisible = false
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 确定员工
    confirmEmployee() {
      if (this.employeeId) {
        this.dialogVisible = false
      } else {
        this.$message.error("请选择员工")
      }
    },
    // 下单
    placeOrder(type) {
      if (this.order.length == 0) {
        this.$message.error("请选择服务项目")
        // } else if (!this.employeeId) {
        // this.$message.error("请选择员工")
      } else if (!this.member.memberCode) {
        // this.dialogTitle = "扫码注册会员"
        // this.dialogVisible = true
        this.$message.error("未选择会员，无法开单")
      } else {
        this.btnloading = true
        let orderAmount = this.type == 1 ? this.order[0].price : this.package.price
        let discountRate = Number(this.member.discountRate) / 10 // 折扣率
        let discountAmount = (Number(orderAmount) - Number(orderAmount) * Number(discountRate)).toFixed(2) // 优惠金额
        let payAmount = (Number(orderAmount) - Number(discountAmount)).toFixed(2) // 支付金额
        this.ruleForm = {
          payType: "", // 支付类型:1.线上支付,2.现金支付,3会员卡支付
          userId: this.member.userId, // 用户id
          memberCode: this.member.memberCode, // 会员卡号
          balance: this.member.balance || 0, // 会员余额(弹窗用)
          orderAmount: orderAmount, // 订单金额
          storeId: this.$store.state.userInfo.bizId, // 门店id
          projectType: this.type == 1 ? 1 : 3, // 服务项目 or 套餐
          discountRate: this.member.discountRate || 0, // 折扣率
          discountAmount: this.member.discountRate ? discountAmount : 0, // 优惠金额
          payAmount: this.member.discountRate ? payAmount : orderAmount, // 支付金额
        }
        this.ruleForm.addProjectInfoListDtoList = this.order.map(item => {
          return {
            ...item,
            projectType: this.type == 1 ? 1 : 3,
            packageId: this.package.packageId || null,
            originalPrice: item.price,
            projectId: item.projectId || null,
          }
        })
        this.$axios
          .post(this.$api.cashier_orderproject_save_order, this.ruleForm)
          .then(res => {
            this.$message.success("下单成功")
            setTimeout(() => {
              if (type == 1) {
                this.ruleForm.orderCode = res.result.orderCode
                this.ruleForm.id = res.result.id
                this.dialogTitle = "支付"
                this.dialogVisible = true
                this.btnloading = false
              } else {
                this.$router.go(-1)
                this.btnloading = false
              }
            }, 1000)
          })
          .catch(err => {
            this.btnloading = false
            this.$message.error(err.desc)
          })
      }
    },
    // 支付
    confirmPay() {
      if (!this.ruleForm.payType) {
        this.$message.error("请选择支付方式")
        return
      }

      let api = ""
      let params = {}
      if (this.ruleForm.payType == 1) {
        // api = this.$api.cashier_orderwechat_code_pay_order
        // params = {
        //   userPayCode: this.ruleForm.payCode,
        //   orderCode: this.ruleForm.orderCode,
        //   payAmount: this.ruleForm.orderAmount, // 支付金额
        //   // payAmount: 0.01, // 支付金额
        // }
        api = this.$api.cashier_orderhuifuReversePay
        params = {
          title: "项目二维码主动支付",
          userId: 0,
          payType: Number(this.ruleForm.payType),
          sourceNum: this.ruleForm.orderCode,
          userPayCode: this.ruleForm.payCode,
          sourceType: 1,
          sourceId: this.ruleForm.id,
          payPrice: this.ruleForm.orderAmount, // 支付金额
          // payAmount: 0.01, // 支付金额
        }
      } else {
        api = this.$api.cashier_orderproject_pay_order
        params = {
          id: this.ruleForm.id,
          memberCode: this.ruleForm.memberCode,
          payType: Number(this.ruleForm.payType),
          orderAmount: this.ruleForm.orderAmount, // 订单金额
          discountRate: this.ruleForm.discountRate || 0, // 折扣率
          discountAmount: this.ruleForm.discountAmount, // 优惠金额
          payAmount: this.ruleForm.payAmount, // 支付金额
        }
      }

      this.btnloading = true
      this.$axios
        .post(api, params)
        .then(res => {
          this.$message.success("付款成功")
          setTimeout(() => {
            this.btnloading = false
            this.$router.go(-1)
          }, 1000)
        })
        .catch(err => {
          this.btnloading = false
          this.$message.error(err.desc)
        })
    },
    //扫码支付
    confirmPayNew() {
      this.btnloading = false
      this.$router.go(-1)
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.list = []
      this.pageSize = e
      this.getProjectInfoselectProjectInfoList()
    },
    // 换页
    handleCurrentChange(e) {
      this.list = []
      this.currentPage = e
      this.getProjectInfoselectProjectInfoList()
    },
    // 切换每页显示的条数 - 会员
    handleSizeChange1(e) {
      this.memberList = []
      this.pageSize1 = e
      this.getMemberList()
    },
    // 换页 - 会员
    handleCurrentChange1(e) {
      this.memberList = []
      this.currentPage1 = e
      this.getMemberList()
    },
    // 切换每页显示的条数 - 员工
    handleSizeChange2(e) {
      this.staffList = []
      this.pageSize2 = e
      this.getStaffList()
    },
    // 换页 - 员工
    handleCurrentChange2(e) {
      this.staffList = []
      this.currentPage2 = e
      this.getStaffList()
    },
  },
}
</script>

<style scoped lang="scss">
.add_service_order {
  display: flex;
  justify-content: space-between;

  .container {
    flex: 1;
    max-width: calc(100% - 455px);
    padding-right: 20px;
    box-sizing: border-box;

    .list {
      display: flex;
      flex-wrap: wrap;
      min-height: 504px;
      margin-top: 20px;
    }
  }

  .order {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 455px;
    max-width: 455px;
    height: calc(100vh - 20px - 20px - 70px - 2px);
    padding: 15px;
    border: 1px solid #e2e2e2;
    border-radius: 6px 6px 6px 6px;
    box-sizing: border-box;
    overflow-y: auto;

    .selected {
      display: flex;

      .select_member,
      .add_member {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        min-height: 50px;
        margin-bottom: 10px;
        color: $themes;
        font-size: 18px;
        border-radius: 6px;
        background: rgba(23, 119, 217, 0.1);
        cursor: pointer;

        &:hover {
          background: rgba(23, 119, 217, 0.3);
        }

        span {
          margin-left: 5px;
        }
      }
      .add_member {
        margin-left: 10px;
        color: #fff;
        background-color: $themes;
      }
    }

    .member_info {
      position: relative;
      display: flex;
      height: 80px;
      margin-bottom: 10px;
      color: $themes;
      font-size: 16px;
      padding: 12px;
      border-radius: 6px 6px 6px 6px;
      background: rgba(23, 119, 217, 0.1);
      box-sizing: border-box;

      .avatar {
        img {
          display: block;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-right: 15px;
        }
      }

      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .name {
          display: flex;
          justify-content: space-between;

          .text {
            flex: 1;
            font-weight: bold;
            display: -webkit-box;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .balance {
            flex: 1;
            font-weight: bold;
            text-align: right;
          }
        }
      }
    }

    .order_list {
      height: calc(100% - 90px - 90px);
      padding: 15px 0;
      box-sizing: border-box;
      overflow: hidden;
      overflow-y: auto;

      .item {
        position: relative;
        color: $themes;
        font-size: 16px;
        padding: 12px;
        margin-bottom: 10px;
        border: 1px solid #1777d9;
        border-radius: 6px 6px 6px 6px;
        background: rgba(23, 119, 217, 0.1);

        .cell {
          display: flex;
          justify-content: space-between;

          .name {
            display: -webkit-box;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .name,
          .technician {
            flex: 2;
          }

          .price,
          .duration {
            flex: 1;
            text-align: right;
          }
        }

        .cell1 {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 8px;
        }
      }
    }
    .order_total {
      height: 30px;
      padding: 10px 0;
      color: $themes;
      font-size: 18px;
      font-weight: bold;
      text-align: right;
    }
    .add_order {
      display: flex;
      flex-direction: column;
      height: 90px;
      background-color: #fff;

      .el-button:last-child {
        margin: 10px 0 0;
      }
    }
  }

  .close {
    position: absolute;
    top: -3px;
    right: -3px;
    font-size: 20px;
    cursor: pointer;

    &:hover {
      opacity: 0.6;
    }
  }

  .dialog_changevip {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .text {
      font-size: 16px;
      color: #707070;
      margin-top: 20px;

      span {
        margin-left: 6px;
      }
    }
  }

  .dialog_member_list {
    padding-top: 20px;

    .item {
      display: flex;
      position: relative;
      color: #707070;
      font-size: 16px;
      padding: 12px;
      margin-bottom: 15px;
      border: 1px solid #f4f6f9;
      border-radius: 6px 6px 6px 6px;
      background: #f4f6f9;
      cursor: pointer;

      .avatar {
        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-right: 15px;
        }
      }

      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .name {
          display: flex;
          justify-content: space-between;

          .text {
            flex: 1;
            font-weight: bold;
            display: -webkit-box;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .balance {
            flex: 1;
            font-weight: bold;
            text-align: right;
          }
        }

        .num {
          display: flex;

          .cards {
            margin-right: 50px;
          }
        }
      }
    }

    .is_ac {
      color: $themes;
      border-color: #1777d9;
      background: rgba(23, 119, 217, 0.1);
    }
  }

  .tabs {
    ::v-deep .el-tabs__nav-wrap::after {
      height: 0;
    }

    ::v-deep .el-tabs__item {
      font-size: 16px;
      padding: 0 15px;
    }

    ::v-deep .el-tabs__item.is-active {
      font-weight: bold;
    }

    ::v-deep .el-tabs__active-bar {
      height: 4px;
      border-radius: 10px;
    }
  }

  .dialog_employee {
    .employee_list {
      display: flex;
      flex-wrap: wrap;

      .employee_list_item {
        display: flex;
        align-items: center;
        width: 295px;
        height: 95px;
        padding: 10px;
        margin-right: 15px;
        margin-bottom: 15px;
        font-size: 14px;
        color: #707070;
        background: #fff;
        box-shadow: 0px 3px 30px 1px rgba(38, 30, 3, 0.04);
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #e8e8e8;
        box-sizing: border-box;
        cursor: pointer;

        .icon {
          font-size: 20px;
        }

        .avatar img {
          border-radius: 50%;
          margin: 0 10px;
        }

        .info {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          height: 100%;

          .name {
            color: #0f1c40;
            font-weight: bold;
          }

          .overt {
            display: -webkit-box;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      .employee_ac {
        color: $themes;
        border-color: $themes;
      }
    }
  }
}
</style>
